import Vue from 'vue'

export const makeBid = data => Vue.axios.post('bids', data)
export const getUnratedBidSessions = view => Vue.axios.get(`bidSessions/unrated/${view}`)
export const giveFeedback = (id, data) => Vue.axios.put(`bidSessions/${id}/advertiserFeedback`, data)
export const rateUser = (id, data) => Vue.axios.put(`bidSessions/${id}/userRating`, data)
export const getBids = id => Vue.axios.get(`bidSessions/${id}/bids`)
export const getDetailedPdf = (id, view) => Vue.axios.get(`bidSessions/${id}/detailedPdf/${view}`, { responseType: 'arraybuffer' })
export const deleteBidSession = id => Vue.axios.delete(`bidSessions/${id}`)



// WEBPACK FOOTER //
// ./src/services/bids.js